<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="考勤忘刷报备"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="showQuery"
      :get-data-func="api.taskFilingList"
    >
      <template slot="toolbar-right">
        <el-button size="mini" class="filter-item" type="success" plain @click="onExport">导出</el-button>
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="姓名">
          <el-input v-model="params.TeacherName" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item label="报备类型">
          <el-select v-model="params.bblx" clearable size="mini">
            <el-option :value="0" label="签到"></el-option>
            <el-option :value="1" label="签退"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="报备事件">
          <el-select v-model="params.EventName" filterable clearable>
            <el-option v-for="item in eveList" :key="item.AttendanceEventId" :label="item.EventName" :value="item.EventName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="考勤日期">
          <el-date-picker
            v-model="params.StartDate"
            placeholder="开始日期"
            clearable
            style="width:184px;"
            value-format="yyyy-MM-dd"
          />
          -
          <el-date-picker
            v-model="params.EndDate"
            placeholder="结束日期"
            clearable
            style="width:184px;"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TeacherName" label="姓名"/>
        <el-table-column prop="DpNames" label="部门"/>
        <el-table-column prop="EventDate" label="考勤日期">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EventDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EventName" label="事件名称"/>
        <el-table-column label="事件时段">
          <template slot-scope="{row}">
            <!-- <span>{{$commonJs.toDateString(row.TimeBucketStart)}}</span>
            -
            <span>{{$commonJs.toDateString(row.TimeBucketEnd)}}</span> -->
            <span>{{showTime(row.TimeBucketStart)}}</span>
            -
            <span>{{showTime(row.TimeBucketEnd)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SignInTime" label="签到时间" min-width="140"/>
        <el-table-column prop="SignOutTime" label="签退时间" min-width="140"/>
        <el-table-column prop="SignInFilingTime" label="签到报备时间" min-width="140"/>
          <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.SignInFilingTime)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="SignOutFilingTime" label="签退报备时间"  min-width="140"/>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/attendance/teachersetting").default,
      eveApi: require("@/api/attendance/teachersetting").default,
      isMB: this.$store.state.isMB,
      params: {
        TeacherName: "",
        EventName: "",
        StartDate: "",
        EndDate: "",
        IsFiling: true
      },
      eveList: [],
    };
  },
  mounted() {
    this.eveApi.list({ Status: 1 }).then(res => {
      if(res.Code==0) {
        this.eveList = res.Data;
      }
    })
  },
  methods: {
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams))
    },
    showTime(v) {
      if(!v) return "";
      var arr = v.split(" ");
      var arr2 = arr[1].split(":");
      return arr2[0] + " : " + arr2[1];
    }
  }
}
</script>